import PropTypes from "prop-types";

function ALSkeleton({ width = "100%", height = "100%", position = "relative", className = "" }) {
  return (
    <div
      className={`relative overflow-hidden bg-light-grey rounded ${className}`}
      style={{ width, height, position }}
      data-testid="al-skeleton"
    >
      <span className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/60 to-transparent" />
    </div>
  );
}

ALSkeleton.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  position: PropTypes.string,
  className: PropTypes.string,
};

export default ALSkeleton;
